import { render, staticRenderFns } from "./GmResolutionSelectModalContent.vue?vue&type=template&id=2709f954&scoped=true&"
import script from "./GmResolutionSelectModalContent.vue?vue&type=script&lang=ts&"
export * from "./GmResolutionSelectModalContent.vue?vue&type=script&lang=ts&"
import style0 from "./GmResolutionSelectModalContent.vue?vue&type=style&index=0&id=2709f954&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2709f954",
  null
  
)

export default component.exports